import log from "./log.js";
import product from "./product.js";
import Layout from "@/layout/views/index";
import routing from "./routing.js";
export default [
  {
    path: "/",
    component: Layout,
    redirect: "/dashboard",
    children: [
      {
        path: "/dashboard",
        component: resolve => require(["@/layout/views/dashboard"], resolve),
        name: "Dashboard",
        isLogin: true,
        meta: {
          title: "首页",
          icon: "dashboard",
          affix: true
        }
      },
      ...product,
      ...routing,
      {
        path: "/user",
        component: resolve => require(["@/views/user/user.vue"], resolve),
        name: "个人中心",
        meta: {
          title: "个人中心",
          affix: true
        }
      },
      {
        path: "/current",
        component: resolve => require(["@/views/current/current.vue"], resolve),
        name: "白名单管理",
        meta: {
          title: "白名单管理",
          affix: true
        }
      },
      {
        path: "/system/user",
        component: resolve =>
          require(["@/manage/views/account/list.vue"], resolve),
        name: "用户管理",
        meta: {
          title: "用户管理",
          affix: true
        }
      },
      {
        path: "/system/role",
        component: resolve =>
          require(["@/manage/views/role/list.vue"], resolve),
        name: "角色列表",
        meta: {
          title: "角色列表"
        }
      },
      {
        path: "/system/platform",
        component: resolve =>
          require(["@/manage/views/platform/platform.vue"], resolve),
        name: "平台管理",
        meta: {
          title: "平台管理"
        }
      },
      {
        path: "/system/post",
        component: resolve =>
          require(["@/manage/views/post/post.vue"], resolve),
        name: "岗位管理",
        meta: {
          title: "岗位管理",
          affix: true
        }
      },
      {
        path: "/system/dept",
        component: resolve =>
          require(["@/manage/views/dept/dept.vue"], resolve),
        name: "部门管理",
        meta: {
          title: "部门管理",
          affix: true
        }
      },
      {
        path: "/system/config",
        component: resolve =>
          require(["@/manage/views/config-view/config.vue"], resolve),
        name: "参数管理",
        meta: {
          title: "参数管理",
          affix: true
        }
      },
      {
        path: "/monitor/online",
        component: resolve =>
          require(["@/manage/views/online/online.vue"], resolve),
        name: "参数管理",
        meta: {
          title: "参数管理",
          affix: true
        }
      },
      {
        path: "/system/notice",
        component: resolve =>
          require(["@/manage/views/notice/notice.vue"], resolve),
        name: "通知公告",
        meta: {
          title: "通知公告",
          affix: true
        }
      },
      {
        path: "/system/menu",
        component: resolve =>
          require(["@/manage/views/permissions/list.vue"], resolve),
        name: "菜单列表",
        meta: {
          title: "菜单列表",
          affix: true
        }
      },
      ...log,
      {
        path: "/setting/system",
        component: resolve =>
          require(["@/manage/views/setting/system.vue"], resolve),
        name: "通用设置",
        meta: {
          title: "通用设置",
          affix: true
        }
      },
      {
        // 计划
        path: "/monitor/job",
        component: resolve =>
          require(["@/manage/views/plan/plan.vue"], resolve),
        name: "计划管理",
        meta: {
          title: " 计划管理",
          affix: true
        }
      }
    ]
  }
];
